import React, { useContext } from 'react'
import { useCallback } from 'react'

export const Context = React.createContext({})

export const withContext = (Component) => {
  const WrappedComponent = (props) => {
    const contextProps = useContext(Context)
    return (
      <Component
        {...contextProps}
        {...props}
      />
    )
  }
  return WrappedComponent
}

export const useOpenModalForCreate = () => {
  const { showModal } = useContext(Context)
  const fn = useCallback((record) => showModal(record, 'new'), [showModal])
  return fn
}

export const useOpenModalForEdit = () => {
  const { showModal } = useContext(Context)
  const fn = useCallback((record) => showModal(record, 'edit'), [showModal])
  return fn
}

export const useOpenModalForCopy = () => {
  const { showModal } = useContext(Context)
  const fn = useCallback((record) => showModal(record, 'copy'), [showModal])
  return fn
}
